<template>
	<div class="app-footer max-w-full overflow-x-hidden">
		<div class="bg-gray-150 shadow-inner">
			<container>
				<app-sponsors/>
			</container>
		</div>

		<div class="bg-white pt-32">
			<container>
				<row>
					<column :cols="6" :sm="12 / items.length" v-for="(itemGroup,itemsKey) in items" :key="itemsKey">
						<nav-list>
							<nav-list-header x-small class="pl-16">{{ itemGroup.title }}</nav-list-header>
							<nav-list-item v-for="(item, i) in itemGroup.items" :key="i" active-color="primary" small rounded-large :to="item.href ? item.href : item.to"
										   class="mb-4"
										   :exact="item.exact"
										   :text="item.text"/>
						</nav-list>
					</column>
				</row>
				<divider/>
				<div class="flex flex-column-reverse sm:flex-row items-center justify-between w-full mt-24" :class="withoutBottomPadding ? 'mb-24' : 'mb-96'">
					<p class="sm:none text-center text-xs mb-0">&copy; {{ new Date().getFullYear() }} SPOFERAN</p>

					<social-icons :social-media="socialMedia" class="md:w-300 mt-16 mb-24 sm:mb-0 sm:mt-0"/>

					<p class="none sm:block text-center text-xs mb-0">&copy; {{ new Date().getFullYear() }} SPOFERAN</p>

					<div v-if="!$device.isNative" class="md:w-300 mb-16 sm:mb-0">
						<app-feature-buttons center/>

						<div class="flex flex-wrap justify-around items-center">
							<a href="https://strava.com/" rel="noopener" target="_blank" title="Strava" class="p-8">
								<cdn-image class="h-40" :ratio="199/86" src="/logos/strava-compatible-stack-logo.svg"/>
							</a>
							<a href="https://connect.garmin.com/" rel="noopener" target="_blank" title="Garmin Connect" class="p-8">
								<cdn-image :size="{height: 34}" :ratio="1605/365" src="/logos/garmin-compatible-logo.png"/>
							</a>
							<a href="https://www.suunto.com/" rel="noopener" target="_blank" title="Suunto" class="p-8">
								<cdn-image :size="{height: 32}" :ratio="702/250" src="/logos/suunto-compatible-logo.png"/>
							</a>
						</div>
					</div>
				</div>
			</container>
		</div>
	</div>
</template>
<script setup lang="ts">
const props = withDefaults(defineProps<{

	// The navigation items to show
	items: {
		title: string;
		items: {
			text: string;
			href?: string;
			to?: string;
			exact?: boolean;
		}[];
	}[];

	withoutBottomPadding?: boolean;
}>(), {});

const socialMedia = {
	spoferan: 'https://spoferan.com/clubs/spoferan',
	facebook: 'https://www.facebook.com/spoferan',
	instagram: 'https://www.instagram.com/spoferan_de/',
	youtube: 'https://www.youtube.com/channel/UCIJ5AOlFt1Fn41vSTW_QiTw'
}

</script>
<style>
/*********************
  Typography
**********************/
/*********************
  Inputs
**********************/
/*********************
  Shadows
**********************/
/*********************
  Layout
**********************/
/*********************
  Card
**********************/
/*********************
  Opacity
**********************/
body.has-app-bottom-bar .app-footer {
  margin-bottom: 80px;
}
@media (max-width: 767px) {
  body.has-app-bottom-bar .app-footer {
    margin-bottom: 56px;
  }
}
</style>